<template>
  <div class="login-web-modal">
    <!-- 验证码登录 -->
    <div class="web-modal-block" v-if="loginType === 'captcha'">
      <div class="modal-header1">
        <div class="modal-title">登录 / 注册</div>
      </div>
      <div class="modal-body">
        <div class="form-item-block inputheight">
          <input
            type="text"
            placeholder="手机号"
            v-model="mobile"
            class="form-input"
          />
        </div>
        <div class="form-item-block inputheight">
          <input
            type="text"
            placeholder="验证码"
            v-model="mobile_code"
            class="form-input-short"
          /><el-button
            type="text"
            class="verification-code-btn"
            :disabled="!mobile"
            @click="postCaptchaVerify"
            >{{ btnMsg }}</el-button
          >
        </div>

        <div class="form-item-block">
          <div class="form-item-btn-flex">
            <el-button
              class="form-item-btn"
              @click="submit"
              :disabled="!(mobile && mobile_code && checked)"
              >登录</el-button
            >
          </div>
        </div>
        <div class="form-item-block">
          <div class="form-item-btn-3">
            <span
              class="form-text-small"
              @click="
                loginType = loginType == 'captcha' ? 'password' : 'captcha'
              "
              >账号密码登录</span
            >
            <!--  loginType === 'password' ? '验证码登录' : '账号密码登录'  -->
          </div>
        </div>
        <div class="agreement-action">
          <div class="agreement-action-btn">
            <el-checkbox v-model="checked"></el-checkbox>
          </div>
          <div class="agreement-action-info">
            我已阅读并同意
            <a
              target="_blank"
              href="https://bankaoedu.com/policy?type=kgUserPolicy"
              class="agreement-text"
              >《用户协议》</a
            >
            和
            <a
              target="_blank"
              href="https://bankaoedu.com/policy?type=kgPolicy"
              class="agreement-text"
              >《隐私政策》</a
            >
          </div>
        </div>
      </div>
      <!-- <div class="qrcode-wrap"></div> -->
      <!-- == -->

      <!--  -->
    </div>

    <!-- 账号密码登录 -->
    <div class="web-modal-block" v-if="loginType == 'password'">
      <!---->
      <div class="modal-header1">
        <div class="modal-title">登录</div>
      </div>
      <div class="modal-body">
        <div class="form-item-block inputheight">
          <input
            type="text"
            placeholder="手机号或邮箱"
            class="form-input"
            v-model="mobile"
          />
        </div>
        <div class="form-item-block inputheight">
          <input
            type="password"
            placeholder="密码"
            v-model="password"
            class="form-input"
          />
          <!-- <p class="error-tooltip">
            <span class="tooltip-icon"></span>
            &nbsp;&nbsp;&nbsp; <span>??</span>
          </p> -->
        </div>
        <!-- <div class="form-item-block noborder">
          <div class="form-item-btn-2">
            <span>忘记密码?</span>
          </div>
        </div> -->
        <div class="form-item-block noborder">
          <div class="form-item-btn-flex">
            <el-button
              class="form-item-btn"
              @click="pwdSubmit"
              :disabled="!(mobile && password && checked)"
              >登录</el-button
            >
          </div>
        </div>
        <div class="form-item-block noborder">
          <div class="form-item-btn-3">
            <div
              class="form-text-small"
              @click="
                loginType = loginType == 'password' ? 'captcha' : 'password'
              "
            >
              验证码登录/注册
            </div>
          </div>
        </div>
        <div class="agreement-action">
          <div class="agreement-action-btn">
            <el-checkbox v-model="checked"></el-checkbox>
          </div>
          <div class="agreement-action-info">
            我已阅读并同意
            <a
              target="_blank"
              href="https://bankaoedu.com/policy?type=kgUserPolicy"
              class="agreement-text"
              >《用户协议》</a
            >
            和
            <a
              target="_blank"
              href="https://bankaoedu.com/policy?type=kgPolicy"
              class="agreement-text"
              >《隐私政策》</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { captchaVerify, loginMobile, loginPassword } from "@/service/login.js";
const CryptoJS = require("crypto-js");
export default {
  data() {
    return {
      mobile: "",
      mobile_code: "",
      password: "",
      btnMsg: "获取验证码",
      timer: null,
      checked: true,
      loginType: "password", // 默认为账号密码登录
      redirect:null
    };
  },
  created(){
    this.redirect = this.$route.query.redirect
  },
  methods: {
    setTime() {
      if (this.timer) {
        return;
      }
      let time = 60;
      this.btnMsg = "60秒后重新获取";

      this.timer = setInterval(() => {
        time--;
        if (time <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.btnMsg = "获取验证码";
        } else {
          this.btnMsg = `${time}秒后重新获取`;
        }
      }, 1000);
    },
    // crypto-js 加密手机号
    encrypt(word) {
      var keyStr = "dfgresjsdjf3sj43";
      var key = CryptoJS.enc.Utf8.parse(keyStr);

      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    },
    async postCaptchaVerify() {
      var encryptMobile = this.encrypt(JSON.stringify(Number(this.mobile)));

      if (this.timer) return;
      let res = await captchaVerify({
        mobile: encryptMobile,
        scene: "login",
      });
      if (res.code == 0) {
        this.$message.success("发送成功");
        this.setTime();
      }
    },
    async pwdSubmit() {
      let res = await loginPassword({
        mobile: this.mobile,
        password: this.password,
      });
      if (res.code == 0) {
        // 存 token
        localStorage.setItem("token", res.data.token);
        // 跳转 首页
        if(this.redirect){
          this.$router.replace(this.redirect);
        }else{
          this.$router.replace('/');
          // this.$router.replace('/student/myResume');
        }
        
      }
    },
    async submit() {
      let res = await loginMobile({
        mobile: this.mobile,
        mobile_code: this.mobile_code,
      });
      if (res.code == 0) {
        // 存 token
        localStorage.setItem("token", res.data.token);
        // 跳转 首页
          // this.$router.replace('/student/myResume');
        if(this.redirect){
          this.$router.replace(this.redirect);
        }else{
          this.$router.replace('/');
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-web-modal {
  position: fixed;
  text-align: center;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background: url("@/assets/imgs/bg.png");
  // background: #2d3a4b;
  z-index: 999;
}
.web-modal-block {
  display: inline-block;
  -webkit-box-shadow: 0px 20px 80px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 20px 80px 0px rgba(0, 0, 0, 0.3);
  background: #ffffff;
  width: 400px;
  min-height: 375px;
  text-align: left;
  position: relative;
  top: 100px;
  border: 1px solid #ccc;
  border-radius: 8px;
  .modal-header1 {
    padding: 40px 0 0;
    position: relative;
    .modal-title {
      text-align: center;
      font-size: 26px;
      color: #0fce96;
      font-weight: 400;
    }
  }
  .modal-body {
    padding: 4px 40px 40px;
    .form-item-block {
      position: relative;
      border: none;

      text-align: center;

      .verification-code-btn {
        background: #fff;
        width: 120px;
        height: 22px;
        font-size: 16px;
        margin-left: 16px;
        display: inline-flex;
        justify-content: flex-end;
        align-items: center;
        position: relative;
        top: 19px;
      }
      .form-input,
      .form-input-short {
        display: inline-block;
        width: 320px;
        color: #b1b5b9;
        height: 34px;
        border: none;
        font-size: 16px;
        padding: 6px 4px;
        text-align: left;
        position: relative;
        top: 19px;
      }
      .form-input-short {
        width: 180px;
      }
      // .form-item-btn-2 {
      //   cursor: pointer;
      //   text-align: right;
      //   font-size: 14px;
      //   color: #8a9095;
      //   padding-top: 14px;
      // }
      .form-item-btn-3 {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        .form-text-small {
          width: 195px;
          font-size: 14px;
          color: #0fce96;
          text-align: center;
          cursor: pointer;
        }
      }
      .form-item-btn-flex {
        display: flex;
        justify-content: center;
      }
      .form-item-btn {
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 180px;
        margin-top: 40px;
        font-size: 20px;
        color: #fff;
        line-height: 20px;
        background: #0fce96;
        box-shadow: 0 10px 20px #0fce9633;
        border-radius: 24px;
      }
    }
    .form-item-block.inputheight {
      border-bottom: 1px solid rgba(222, 226, 234, 0.5);

      height: 63px;
    }
    .form-item-block.noborder {
      border: none;
    }
    .agreement-action {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 34px;

      .agreement-action-btn {
        width: 22px;
        height: 22px;
        margin-right: 2px;
        background-size: contain;
        background-image: url(//nodestatic.fbstatic.cn/weblts_spa_online/page/check-grey.7fe2925….svg);
      }
      .agreement-action-info {
        font-size: 12px;
        color: #aeb6c2;
      }
    }
  }
}

// .web-modal-block .modal-body .form-item-block
</style>